import { Avatar, Flex } from 'antd';
import styles from './dropdown-item.module.css';

interface DropdownItemProps {
  label: React.ReactNode;
}

const DropdownItem: React.FC<DropdownItemProps> = ({ label }) => {
  const string = label?.toString() || '';
  const segments = string?.split('/');
  return (
    <Flex className={styles.dropdownItem} gap={10} align="center">
      <Flex>
        <Avatar size="small" />
      </Flex>
      <Flex vertical>
        <div className={styles.caption}>{segments[0]}</div>
        <div className={styles.occupation}>{segments[1]}</div>
      </Flex>
    </Flex>
  );
};

export default DropdownItem;
